<template lang="pug">
  div
    export-modal(v-if="showExportModal")
    login-modal(v-if="showAuthModal" :action="showAuthModal")
</template>

<script>

import { mapState, } from 'vuex'
import ExportModal from '@/components/modals/ExportModal'
import LoginModal from '@/components/modals/LoginModal'

export default {
  name: 'SearchModals',
  components: {
    ExportModal,
    LoginModal,
  },
  computed: {
    ...mapState('search', [ 'showExportModal', 'exportFormat', ]),
    ...mapState('auth', [ 'showAuthModal', ]),
  },
}
</script>

<style scoped lang="stylus">

</style>



// WEBPACK FOOTER //
// src/components/search-components/SearchModals.vue